import { createContext } from "react";
import type ProposalField from "work/proposals/proposal-fields/proposal-field";

/**
 * Supplies the proposal page's field navigation — the same "Next/Prev Change" traverser wired to
 * `onTraverseToNewField` — to descendants, chiefly the change-history timeline rendered inside the
 * comments drawer. Passing it by context rather than threading a prop keeps the drawer (owned by a
 * separate workstream) a transparent pass-through and lets the panel stay decoupled from the pages.
 *
 * Undefined when no page provides it (the standalone field-history popover, tests), so consumers
 * degrade to non-interactive rows instead of throwing.
 */
export const ProposalFieldNavigationContext = createContext<((field: ProposalField) => void) | undefined>(
  undefined,
);
